import header from '../modules/header/index';
import toplistJs from '../modules/toplist/toplistIndex';
import addScrollToTop from '../modules/addScrollToTop';
import addHightToImageGalery from '../modules/addHightToImageGalery';
import initSelectForTabs from '../modules/tabPanel/components/initSelectForTabs';
import NewsletterAction from '../modules/newsletterAction';
import {Apptus} from '../modules/apptus/apptus';
import viewModeMobileHandler from '../modules/header/components/viewModeMobileHandler';

import "../../../scss/pages/allStyles.scss";

jQuery(function() {
  header();
  toplistJs()
  addScrollToTop();
  addHightToImageGalery();
  initSelectForTabs();
  viewModeMobileHandler();

  $('.subscription').on('click', function() {
    NewsletterAction($(this));
  });

  $(window).on('click', (e) => {
    let target = e.target;
    var targetParent = $(target).parent();
    if(target.matches('.update-apptus-func') ) {
        Apptus.NotifyClick($(target).attr('data-apptus'))
    }
    if(targetParent.hasClass('update-apptus-func') ) {
        Apptus.NotifyClick($(targetParent).attr('data-apptus'))
    }
  })
})